import { render, staticRenderFns } from "./queryupdate.vue?vue&type=template&id=ef2a7e26"
import script from "./queryupdate.vue?vue&type=script&lang=js"
export * from "./queryupdate.vue?vue&type=script&lang=js"
import style0 from "./queryupdate.vue?vue&type=style&index=0&id=ef2a7e26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports